<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>To Ed and Peggy Wells, with thanks for their love and faith through the years.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?5858746b